import { PointLocation } from "../data/LockerDataTypes";
import { IMapCenter } from "../data/MapCenter";
import { isObjectNullOrEmpty } from "../services/lockerService";

export class WorkFavouriteLockerMapCenter implements IMapCenter {
    value: any;
    order: number;

    constructor(value: any, order: number) {
        this.value = value;
        this.order = order;
    }

    IsApplicable(): boolean {
        return isObjectNullOrEmpty(this.value) === false;
    };

    async Run(): Promise<PointLocation> {
        return {lng: this.value.lng, lat: this.value.lat} as PointLocation
    };
}